import { createSlice } from "@reduxjs/toolkit";
import { NewFlow } from "../declarations/interface";

const DEFAULT: NewFlow = {
  recording_id: "",
  project_id: "",
  workflow_name: "",
  allow_loop: true,
  dom_lists: [],
  window_metadata: {},
};

const slice = createSlice({
  name: "flow",
  initialState: DEFAULT,
  reducers: {
    updateFlowName(state, action) {
      state.workflow_name = action.payload;
    },
    loadMetadata(state, action) {
      state.window_metadata = action.payload;
    },
    loadSnapshots(state, action) {
      state.recording_id = action.payload.recording_id;
      state.project_id = action.payload.project_id;
      state.workflow_name = action.payload.workflow_name;
      state.workflow_id = action.payload.workflow_id;
      state.allow_loop = action.payload.allow_loop;
      state.dom_lists = [];
    },
    setAllowLoop(state, action) {
      state.allow_loop = action.payload;
    },
    concatDomLists(state, action) {
      const { append, list } = action.payload;
      if (append) {
        state.dom_lists = [...state.dom_lists, ...list];
      } else {
        state.dom_lists = list;
      }
    },
    checkSnapshot(state, action) {
      //payload has dom_uuid
      state.dom_lists.map((dom) => {
        if (
          dom.dom_uuid === action.payload ||
          dom.snapshot_id === action.payload
        ) {
          dom.checked = !dom.checked;
        }
      });
    },
    selectAll(state, action) {
      //payload has boolean
      state.dom_lists.map((dom) => {
        dom.checked = action.payload;
      });
    },
    updateSnapshot(state, action) {
      const { id, field, value } = action.payload;
      state.dom_lists.map((dom) => {
        if (dom.dom_uuid === id || dom.snapshot_id === id) {
          switch (field) {
            case "delay_interval":
              dom.delay_interval = `${Number(value) * 1000}`;
              dom.display_delay_interval = value;
              dom.wait_type = "TIME";
              break;
            case "wait_type":
              dom.wait_type = value;
              dom.upload_enabled = null;
              dom.api_key = null;
              dom.download_key = null;
              break;
            case "event_id":
              dom.event_id = value;
              dom.wait_type = "EVENT";
              break;
            case "api_key":
              dom.api_key = value;
              dom.download_key = null;
              dom.upload_enabled = null;
              break;
            case "download_key":
              dom.download_key = value;
              dom.api_key = null;
              dom.upload_enabled = null;
              break;
            case "upload_enabled":
              dom.upload_enabled = value === "true";
              dom.api_key = null;
              dom.download_key = null;
              break;
            case "REMOVE_ACTIONS": {
              dom.upload_enabled = null;
              dom.api_key = null;
              dom.download_key = null;
            }
          }
        }
      });
    },
    unCheckSnapshotsWithoutEvents(state) {
      state.dom_lists.map((dom) => {
        if (dom.events_lists?.length > 0) {
          dom.checked = true;
        } else {
          dom.checked = false;
        }
      });
    },
    updateDomModification(state, action) {
      const { id, item, index } = action.payload;
      state.dom_lists.map((dom) => {
        if (dom.dom_uuid === id || dom.snapshot_id === id) {
          if (dom.dom_modifications) {
            if (index < dom.dom_modifications.length) {
              const dom_modification = dom.dom_modifications[index];
              dom_modification.description = item.description;
              dom_modification.oldContent = item.oldContent;
              dom_modification.newContent = item.newContent;
            } else {
              dom.dom_modifications.push({
                ...item,
                workflow_sequence_id: dom.workflow_sequence_id,
              });
            }
          } else {
            dom.dom_modifications = [
              {
                ...item,
                workflow_sequence_id: dom.workflow_sequence_id,
              },
            ];
          }
        }
      });
    },
    deleteDomModification(state, action) {
      const { id, index } = action.payload;
      state.dom_lists.map((dom) => {
        if (dom.dom_uuid === id || dom.snapshot_id === id) {
          if (dom.dom_modifications) {
            const dom_modification = dom.dom_modifications[index];
            if (dom_modification.id) {
              dom_modification.isDeleted = !dom_modification.isDeleted;
            } else {
              dom.dom_modifications.splice(index, 1);
            }
          }
        }
      });
    },
  },
});

export const reducer = slice.reducer;
export const actions = slice.actions;

export default slice;
